import React from 'react'
import { Select, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import TimePeriodOptionSelect from '../TimePeriodOptionSelect'
import { NodeContentProps } from '../../types'
import { OffsetControls, TimePeriodControl } from '../TimePeriodControl'
import { CustomReportCategory } from '../../../../../../../../redux/context/customReports/typesCategory'
import ScenarioCascader from '../../../../../../../../features/scenario/components/cascader/ScenarioCascader'
import { ReportDataType } from '../../../../../../../../redux/context/reports/types'

const PeriodGroupNodeContent: React.FC<NodeContentProps> = ({ node, context, onUpdateValue }) => {
  const { t } = useTranslation()
  // Create a safe value for the ScenarioCascader
  // Filter out undefined values and ensure we have an array
  const cascaderValue = [node.dataType, node.budgetingScenarioId].filter(
    value => value !== undefined && value !== null
  ) as (string | number)[]

  const select = context.company ? (
    <ScenarioCascader
      companyId={context.company}
      value={cascaderValue}
      style={{ width: '200px' }}
      styles={{
        popup: {
          root: {
            minWidth: '200px'
          }
        }
      }}
      onChange={([dataType, budgetingScenarioId]) => {
        return onUpdateValue(node.id, {
          dataType: dataType as CustomReportCategory['dataType'],
          budgetingScenarioId: budgetingScenarioId as number | null
        })
      }}
      data-cy={`scenario-cascader-${node.id}`}
    />
  ) : (
    <Select
      value={node.dataType || ReportDataType.actuals}
      style={{ width: '200px' }}
      onChange={value => onUpdateValue(node.id, { dataType: value as CustomReportCategory['dataType'] })}
      options={[ReportDataType.actuals, ReportDataType.budget].map(value => ({ value, label: t(`global:${value}`) }))}
    />
  )
  return (
    <Space>
      <TimePeriodOptionSelect
        value={node.value}
        onChange={value => onUpdateValue(node.id, { value })}
        data-cy={`period-option-select-${node.id}`}
      />
      {select}
      <OffsetControls
        category={node as unknown as CustomReportCategory}
        onChange={value => onUpdateValue(node.id, value)}
        data-cy={`offset-controls-${node.id}`}
      />
      <TimePeriodControl
        category={node as unknown as CustomReportCategory}
        onChange={value => onUpdateValue(node.id, value)}
        data-cy={`time-period-control-${node.id}`}
      />
    </Space>
  )
}

export default PeriodGroupNodeContent
